import { useEffect } from 'react';

import { useAppDispatch } from 'src/app/store/hooks';

import { RouteTemplateDataGrid } from './management/RouteTemplateDataGrid';
import { RouteTemplateFormModal } from './modals/RouteTemplateFormModal';
import { routeTemplateActions } from './routeTemplates.slice';

export function RouteTemplatesScreen() {
  const dispatch = useAppDispatch();
  // Reset filters because of the preselected day filter
  useEffect(() => {
    dispatch(routeTemplateActions.clearFilters());
  }, [dispatch]);

  return (
    <>
      <RouteTemplateDataGrid />
      <RouteTemplateFormModal />
    </>
  );
}
